import {Routes, Route} from 'react-router-dom'
import {FeedEditarCategorias} from '../pages/Hospitality/Content/Category/update'
import {CriarServico} from '../pages/Commons/Servicos/create'
import {ListarServicos} from '../pages/Commons/Servicos/listar'
import {EditarServico} from '../pages/Commons/Servicos/update'
import {HospitalityIcones} from '../pages/Hospitality/Configuracoes/Icones'
import {HospitalitySetores} from '../pages/Hospitality/Configuracoes/Setores'
import {HospitalityCriarSetor} from '../pages/Hospitality/Configuracoes/Setores/create'
import {HospitalityEditarSetor} from '../pages/Hospitality/Configuracoes/Setores/update'
import {FeedCategorias} from '../pages/Hospitality/Content/Category'
import {FeedCriarCategorias} from '../pages/Hospitality/Content/Category/create'
import {FeedConteudos} from '../pages/Hospitality/Content/Content'
import {FeedCriarConteudo} from '../pages/Hospitality/Content/Content/create'
import {Categorias as ServiceCategory} from '../pages/Commons/Servicos/Category'
import {CriarCategorias as ServiceCategoryCreate} from '../pages/Commons/Servicos/Category/create'
import {EditarCategorias as ServiceCategoryUpdate} from '../pages/Commons/Servicos/Category/update'
import {CleanSafe} from '../pages/Hospitality/ContentStructured/CleanSafe'
import {ServiceRequestsIndex} from '../pages/Hospitality/ContentStructured/ServiceResquests'
import {CreateHotelRoom, EditHotelRoom, HotelRoom} from '../pages/Hospitality/HotelRoom'
import {
  HotelRoomReservation,
  CreateHotelReservation,
  EditHotelReservation,
} from '../pages/Hospitality/HotelRoomReservation'
import {HotelActivities} from '../pages/Hospitality/Activities'
import {CreateHotelActivity, EditHotelActivity} from '../pages/Hospitality/Activities'
import {GradesHotel} from '../pages/Hospitality/ContentStructured/GridHotel/index'
import {GradesFeedBackHotel} from '../pages/Hospitality/feedback/GridFeedBack/index'
import {CriarGradesHotelFeedBack} from '../pages/Hospitality/feedback/GridFeedBack/create'
import {EditarGradesHotelFeedBack} from '../pages/Hospitality/feedback/GridFeedBack/update'
import {CriarGradesHotel} from '../pages/Hospitality/ContentStructured/GridHotel/create'
import {EditarGradesHotel} from '../pages/Hospitality/ContentStructured/GridHotel/update'
import {ServiceRequestsCreate} from '../pages/Hospitality/ContentStructured/ServiceResquests/create'
import {ServiceRequestsEdit} from '../pages/Hospitality/ContentStructured/ServiceResquests/edit'
import {HotelTour, CreateHotelTour, EditHotelTour} from '../pages/Hospitality/Tour'
import {
  CreateHotelExperience,
  HotelExperiences,
  UpdateHotelExperience,
} from '../pages/Hospitality/Experiences'
import {TestTranslations} from '../components/TestTranslations'
import {HotelInfo} from '../pages/Hospitality/Info/Index'
// import { HotelReserves } from '../pages/Hospitality/TourReservation';
import {SchedulesIndex, ScheduleCreate, ScheduleEdit} from '../pages/Hospitality/Schedules'
import {PublicidadeHotel} from '../pages/Hospitality/publicidade'
import {CriarPublicidadeHotel} from '../pages/Hospitality/publicidade/create'
import {EditarPublicidadeHotel} from '../pages/Hospitality/publicidade/update'
import {PublicidadeBannerHotel} from '../pages/Hospitality/Banner'
import {CriarPublicidadeBannerHotel} from '../pages/Hospitality/Banner/create'
import {EditarPublicidadeBannerHotel} from '../pages/Hospitality/Banner/update'
import {ReviewsHotel} from '../pages/Hospitality/Review'
import {ReviewHotelCreate} from '../pages/Hospitality/Review/create'
import {ReviewHotelEdit} from '../pages/Hospitality/Review/edit'
import {ReviewsHotelResults} from '../pages/Hospitality/Review/results'
import {ReviewsHotelCategory} from '../pages/Hospitality/ReviewCategory'
import {ReviewHotelCategoryCreate} from '../pages/Hospitality/ReviewCategory/create'
import {ReviewHotelCategoryEdit} from '../pages/Hospitality/ReviewCategory/update'
import {OrdersRoomService} from '../pages/Hospitality/Orders/OrdersRoomService'
import {OrdersActivities} from '../pages/Hospitality/Orders/OrdersActivities'
import {OrdersReservationService} from '../pages/Hospitality/Orders/OrdersReservationService'

import {HotelStores} from '../pages/Hospitality/Stores'
import {HotelCreateStores} from '../pages/Hospitality/Stores/create'
import {HotelEditStores} from '../pages/Hospitality/Stores/edit'
import CommunicationCenter from '../pages/Commons/communication-center/CommunicationCenter'

// import {FeedbackList} from '../pages/Hospitality/feedback/FeedbackList'
import {SatisfactionFeedbackCreate} from '../pages/Hospitality/feedback/SatisfactionFeedback/create'
import {SatisfactionFeedbackEdit} from '../pages/Hospitality/feedback/SatisfactionFeedback/update'
import {SatisfactionFeedbackIndex} from '../pages/Hospitality/feedback/SatisfactionFeedback'
import {SectionConteudos} from '../pages/Hospitality/Content/section'
import {PostIndex} from '../pages/Hospitality/Posts/Post'
import {PostCriar} from '../pages/Hospitality/Posts/Post/create'
import {PostEdit} from '../pages/Hospitality/Posts/Post/edit'
import {PostCategoryCriar} from '../pages/Hospitality/Posts/Category/create'
import {PostCategoryEditar} from '../pages/Hospitality/Posts/Category/update'
import {PostCategoryIndex} from '../pages/Hospitality/Posts/Category'
import {SectionCreate} from '../pages/Hospitality/Content/section/create'
import {SectionEdit} from '../pages/Hospitality/Content/section/edit'
import {FeedbackReviews} from '../pages/Hospitality/feedback/SatisfactionFeedback/indexReviews'
import {FeedbackAnalyticsDashboard} from '../modules/apps/feedback-analytics'
import FeedbackDiagnostic from '../modules/apps/feedback-analytics/FeedbackDiagnostic'
import {GradesBooking} from '../pages/Hospitality/BookingHotel/GridBooking'
import {GradesBookingCreate} from '../pages/Hospitality/BookingHotel/GridBooking/create'
import {GradesBookingUpdate} from '../pages/Hospitality/BookingHotel/GridBooking/update'

import {BookingHotelCreatePage} from '../pages/Hospitality/BookingHotel/Booking/create'
import {BookingIndex} from '../pages/Hospitality/BookingHotel/Booking/index'
import {BookingHotelUpdatePage} from '../pages/Hospitality/BookingHotel/Booking/update'
import {HotelEditarStatus} from '../pages/Hospitality/Configuracoes/MessageHotel/update'
import {HotelSms} from '../pages/Hospitality/Configuracoes/MessageHotel'
import {ReviewHotelAnalyticsIndex} from '../pages/Hospitality/ReviewCategory/analytics'

const HotelPrivateRoutes = () => {
  return (
    <Routes>
      {/* SETORES HOSPITALITY */}
      <Route path='configuracoes/setores' element={<HospitalitySetores />} />
      <Route path='configuracoes/setores/criar' element={<HospitalityCriarSetor />} />
      <Route path='configuracoes/setores/editar/:id' element={<HospitalityEditarSetor />} />

      <Route path='configuracoes/stores' element={<HotelStores />} />
      <Route path='configuracoes/stores/create' element={<HotelCreateStores />} />
      <Route path='configuracoes/stores/edit/:id' element={<HotelEditStores />} />

      <Route path='configuracoes/icones' element={<HospitalityIcones />} />

      <Route path='configuracoes/message_hotel' element={<HotelSms />} />
      <Route path='configuracoes/message_hotel/edit/:id' element={<HotelEditarStatus />} />

      {/* Serviços */}
      <Route path='service-item' element={<ListarServicos />} />
      <Route path='service-item/create' element={<CriarServico />} />
      <Route path='service-item/update/:id' element={<EditarServico />} />

      {/* Service Category */}
      <Route path='service-category' element={<ServiceCategory />} />
      <Route path='service-category/create' element={<ServiceCategoryCreate />} />
      <Route path='service-category/update/:id' element={<ServiceCategoryUpdate />} />

      {/* Feed */}
      <Route path='content/category' element={<FeedCategorias />} />
      <Route path='content/category/criar' element={<FeedCriarCategorias />} />
      <Route path='content/category/editar/:id' element={<FeedEditarCategorias />} />
      <Route path='content/content' element={<FeedConteudos />} />
      <Route path='content/content/create' element={<FeedCriarConteudo />} />

      {/* Seção da Interface do WebApp do hotel */}
      <Route path='content/section' element={<SectionConteudos />} />
      <Route path='content/section/criar' element={<SectionCreate />} />
      <Route path='content/section/editar/:id' element={<SectionEdit />} />

      {/* Seção da Interface do WebApp do hotel */}
      <Route path='content/section' element={<SectionConteudos />} />
      <Route path='content/section/criar' element={<SectionCreate />} />
      <Route path='content/section/editar/:id' element={<SectionEdit />} />

      {/* Hotel Room  */}
      <Route path='hotel-room'>
        <Route index element={<HotelRoom />} />
        <Route path='criar' element={<CreateHotelRoom />} />
        <Route path='editar/:id' element={<EditHotelRoom />} />
      </Route>

      {/* Teste de Traduções */}
      <Route path='teste-traducoes' element={<TestTranslations />} />

      <Route path='hotel-reservation'>
        <Route index element={<HotelRoomReservation />} />
        <Route path='criar' element={<CreateHotelReservation />} />
        <Route path='editar/:id' element={<EditHotelReservation />} />
      </Route>

      {/* Hotel Activities  */}
      <Route path='hotel-activities'>
        <Route index element={<HotelActivities />} />
        <Route path='criar' element={<CreateHotelActivity />} />
        <Route path='editar/:id' element={<EditHotelActivity />} />
      </Route>

      {/* Serviço Estruturado */}
      <Route path='structured-content'>
        {/* Clean Safe */}
        <Route path='clean-safe' element={<CleanSafe />} />
        {/* Formulário */}
        <Route path='service-requests/create' element={<ServiceRequestsCreate />} />
        <Route path='service-requests/edit/:id' element={<ServiceRequestsEdit />} />
        <Route path='service-requests' element={<ServiceRequestsIndex />} />
        {/* Grades */}
        <Route path='grid-hotel' element={<GradesHotel />} />
        <Route path='grid-hotel/create' element={<CriarGradesHotel />} />
        <Route path='grid-hotel/edit/:id' element={<EditarGradesHotel />} />
      </Route>

      {/*Turismo Do Hotel */}
      <Route path='tours'>
        <Route index element={<HotelTour />} />
        <Route path='criar' element={<CreateHotelTour />} />
        <Route path='editar/:id' element={<EditHotelTour />} />
      </Route>

      {/*Experiencias Do Hotel */}
      <Route path='hotel-experiences'>
        <Route index element={<HotelExperiences />} />
        <Route path='criar' element={<CreateHotelExperience />} />
        <Route path='editar/:id' element={<UpdateHotelExperience />} />
      </Route>

      {/*Informacões Do Hotel */}
      <Route path='hotel-info'>
        <Route index element={<HotelInfo />} />
      </Route>

      {/*Todas as reservas Do Hotel */}
      {/* <Route path='tours-reservations'>
        <Route index element={<HotelReserves />} />
      </Route> */}

      {/*Todas as schedules Do Hotel */}
      <Route path='hotel-schedules'>
        <Route index element={<SchedulesIndex />} />
        <Route path='criar' element={<ScheduleCreate />} />
        <Route path='editar/:id' element={<ScheduleEdit />} />
      </Route>

      {/* Pedidos */}
      <Route path='orders'>
        <Route path='room-service' element={<OrdersRoomService />} />
        <Route path='activities' element={<OrdersActivities />} />
        <Route path='service-reservation' element={<OrdersReservationService />} />
      </Route>
      {/*Todas as schedules Do Hotel */}
      <Route path='publicity'>
        <Route path='' element={<PublicidadeHotel />} />
        <Route path='create' element={<CriarPublicidadeHotel />} />
        <Route path='editar/:id' element={<EditarPublicidadeHotel />} />
      </Route>

      <Route path='publicity-banner'>
        <Route path='' element={<PublicidadeBannerHotel />} />
        <Route path='create' element={<CriarPublicidadeBannerHotel />} />
        <Route path='editar/:id' element={<EditarPublicidadeBannerHotel />} />
      </Route>

      {/* GRID FEEDBACK */}
      <Route path='feedback-satisfaction'>
        <Route path='grid-hotel-feedback' element={<GradesFeedBackHotel />} />
        <Route path='grid-hotel-feedback/edit/:id' element={<EditarGradesHotelFeedBack />} />
        <Route path='grid-hotel-feedback/create' element={<CriarGradesHotelFeedBack />} />

        {/* <Route path='feedback-list' element={<FeedbackList />} /> */}
        <Route path='feedback-list' element={<SatisfactionFeedbackIndex />} />
        {/* <Route path='feedback' element={<SatisfactionFeedbackIndex />} /> */}
        <Route path='feedback-list/create' element={<SatisfactionFeedbackCreate />} />
        <Route path='feedback-list/edit/:id' element={<SatisfactionFeedbackEdit />} />

        {/* Página de Reviews de Feedback */}
        <Route path='feedback' element={<FeedbackReviews />} />

        {/* Diagnóstico do Dashboard */}
        <Route path='feedback-diagnostic' element={<FeedbackDiagnostic />} />

        {/* Dashboard de Análise de Feedback */}
        <Route path='analytics' element={<FeedbackAnalyticsDashboard />} />
        <Route path='feedback-analytics' element={<FeedbackAnalyticsDashboard />} />
      </Route>

      {/* Sessão de Post */}
      <Route path='posts'>
        <Route index element={<PostIndex />} />
        <Route path='criar' element={<PostCriar />} />
        <Route path='editar/:id' element={<PostEdit />} />
      </Route>
      {/* Sessão de Post Categorias */}
      <Route path='posts/category'>
        <Route index element={<PostCategoryIndex />} />
        <Route path='criar' element={<PostCategoryCriar />} />
        <Route path='editar/:id' element={<PostCategoryEditar />} />
      </Route>

      {/* Sessão de Post */}
      <Route path='posts'>
        <Route index element={<PostIndex />} />
        <Route path='criar' element={<PostCriar />} />
        <Route path='editar/:id' element={<PostEdit />} />
      </Route>
      {/* Sessão de Post Categorias */}
      <Route path='posts/category'>
        <Route index element={<PostCategoryIndex />} />
        <Route path='criar' element={<PostCategoryCriar />} />
        <Route path='editar/:id' element={<PostCategoryEditar />} />
      </Route>

      {/* Sessão de Post */}
      <Route path='posts'>
        <Route index element={<PostIndex />} />
        <Route path='criar' element={<PostCriar />} />
        <Route path='editar/:id' element={<PostEdit />} />
      </Route>
      {/* Sessão de Post Categorias */}
      <Route path='posts/category'>
        <Route index element={<PostCategoryIndex />} />
        <Route path='criar' element={<PostCategoryCriar />} />
        <Route path='editar/:id' element={<PostCategoryEditar />} />
      </Route>

      {/* Sessão de Post */}
      <Route path='posts'>
        <Route index element={<PostIndex />} />
        <Route path='criar' element={<PostCriar />} />
        <Route path='editar/:id' element={<PostEdit />} />
      </Route>
      {/* Sessão de Post Categorias */}
      <Route path='posts/category'>
        <Route index element={<PostCategoryIndex />} />
        <Route path='criar' element={<PostCategoryCriar />} />
        <Route path='editar/:id' element={<PostCategoryEditar />} />
      </Route>

      {/* Agendamentos */}
      <Route path='context'>
        <Route path='grid-hotel-booking' element={<GradesBooking />} />
        <Route path='grid-hotel-booking/create' element={<GradesBookingCreate />} />
        <Route path='grid-hotel-booking/edit/:id' element={<GradesBookingUpdate />} />

        <Route path='booking_config_hotel' element={<BookingIndex />} />
        <Route path='booking_config_hotel/create' element={<BookingHotelCreatePage />} />
        <Route path='booking_config_hotel/edit/:id' element={<BookingHotelUpdatePage />} />
      </Route>

      <Route path='feed-back'>
        {/* Conteúdo (Formulários) */}
        <Route path='content'>
          <Route index element={<ReviewsHotel />} />
          <Route path='criar' element={<ReviewHotelCreate />} />
          <Route path='edit/:id' element={<ReviewHotelEdit />} />
        </Route>

        {/* Resultados */}
        <Route path='results' element={<ReviewsHotelResults />} />

        {/* Categorias */}
        <Route path='category'>
          <Route index element={<ReviewsHotelCategory />} />
          <Route path='criar' element={<ReviewHotelCategoryCreate />} />
          <Route path='edit/:id' element={<ReviewHotelCategoryEdit />} />
        </Route>

        <Route path='analytics' element={<ReviewHotelAnalyticsIndex />} />
      </Route>

      {/* Central de Comunicação */}
      <Route path='CommunicationCenter'>
        <Route index element={<CommunicationCenter />} />
      </Route>
    </Routes>
  )
}
export {HotelPrivateRoutes}
